import { debounce } from 'throttle-debounce';
import { Box, Input } from '@chakra-ui/react';
import qs from 'qs';

import useAuth from 'hooks/useAuth';
import { useChat } from 'context/chat-context';
import xhr from 'xhr';
import sortConversations from './sortConversations';
import React from 'react';

const ConversationSearch = () => {
  const [searchValue, setSearchValue] = React.useState(null);

  const auth = useAuth();
  const chat = useChat();

  React.useEffect(() => {
    if (searchValue !== null) handleSearch(searchValue);
  }, [searchValue]);

  const handleSearch = React.useCallback(
    debounce(500, async (searchValue) => {
      try {
        chat.setIsSearching(true);

        const query = qs.stringify(
          { pagination: { page: 1, pageSize: 120 } },
          { encodeValuesOnly: true }
        );
        const chatsResponse = await xhr(`/chats/user/${auth.user.id}?${query}`);
        const body = chatsResponse.data;
        const dataList = Array.isArray(body) ? body : body?.data ?? [];

        chat.resetChatPagination?.();

        if (!searchValue) {
          return chat.setConversations(sortConversations(dataList, auth.user?.id));
        }

        const filteredConversations = dataList.filter((el) => {
          const member = el.members.find((m) => m.id !== auth.user.id);

          if (member) {
            return (
              member.first_name.toLowerCase().search(searchValue.toLowerCase()) > -1 ||
              member.last_name.toLowerCase().search(searchValue.toLowerCase()) > -1
            );
          }
        });

        chat.setConversations(sortConversations(filteredConversations, auth.user?.id));
      } catch (error) {
        console.error(error);
      } finally {
        chat.setIsSearching(false);
      }
    }),
    []
  );

  return (
    <Box marginY="15px" paddingX={{ base: 0, md: '8px' }}>
      <Input
        placeholder="¿A quién deseas enviar un mensaje?"
        onChange={(event) => setSearchValue(event.target.value)}
      />
    </Box>
  );
};

export default ConversationSearch;
